module.exports = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\">\n  <title>\n    Fill 1\n  </title>\n  <path d=\"M9.143 16c-2.286-2.286-.457-5.03-2.286-6.857C5.03 7.314 2.286 9.143 0 6.857L16 0 9.143 16z\" fill=\"#15100c\" fill-rule=\"evenodd\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./assets/svg/current-location.svg
// module id = 3691
// module chunks = 168707334958949